import { getFunctions, httpsCallable } from "firebase/functions";

export const ADMIN_CLUB_ID = "cola-stl";

export interface RefundOrderRequest {
  orderId: string;
  reason?: string;
  clubId?: string;
}

export interface RefundOrderResponse {
  success: boolean;
  orderId: string;
  refundedPasses: number;
  refund: {
    id: string;
    status: string;
    paymentId: string;
    amount: number;
    currency: string;
    reason: string;
    createdAt?: string | null;
    updatedAt?: string | null;
  };
}

export async function refundOrder({
  clubId = ADMIN_CLUB_ID,
  orderId,
  reason,
}: RefundOrderRequest): Promise<RefundOrderResponse> {
  const refundOrderCallable = httpsCallable<
    { clubId: string; orderId: string; reason?: string },
    RefundOrderResponse
  >(getFunctions(), "refundOrder");

  const result = await refundOrderCallable({
    clubId,
    orderId,
    reason,
  });

  return result.data;
}
